import * as React from "react";
import { Typography } from "@mui/material";
import { DsiWrapper } from "@iva/gdpr-component";
import { PageContainer } from "#pages/PageContainer";

export const GdprPage = () => (
    <PageContainer>
        <Typography variant="h1">Gdpr</Typography>
        <DsiWrapper url={"whiteboard.vx.igd.fraunhofer.de"} lang={"en"} />
    </PageContainer>
);
